export const StepList = ({ steps, testIdPrefix }) => {
  return (
    <ol className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
      {steps.map((step, i) => (
        <li key={step.title} data-testid={`${testIdPrefix}-step-${i + 1}`}>
          <span className="font-display text-sm tracking-[0.2em] text-[#c9a24b]">
            {String(i + 1).padStart(2, "0")}
          </span>
          <h3 className="font-display mt-3 text-base text-[#f2ede3]">
            {step.title}
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-[#a09a8c]">
            {step.text}
          </p>
        </li>
      ))}
    </ol>
  );
};
